import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import Header from './components/Header22';
import Footer from './components/Footer22';

const Template22Shop = () => {
    const navigate = useNavigate();
    const [activeFilter, setActiveFilter] = useState('All');
    const [sortBy, setSortBy] = useState('featured');
    const [currentPage, setCurrentPage] = useState(1);
    const [wishlist, setWishlist] = useState({});
    const [hoveredCard, setHoveredCard] = useState(null);

    const categories = ['All', 'Chanderi', 'Banarasi', 'Khadi', 'Block Print', 'Chikankari'];

    const sortOptions = [
        { value: 'featured', label: 'Featured' },
        { value: 'price-low', label: 'Price: Low to High' },
        { value: 'price-high', label: 'Price: High to Low' },
        { value: 'newest', label: 'Newest First' },
    ];

    const products = [
        {
            id: 1,
            name: 'Chanderi Silk Saree',
            category: 'Chanderi',
            price: 8999,
            craft: 'Handwoven in Chanderi, MP',
            image: 'https://images.pexels.com/photos/10679171/pexels-photo-10679171.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 2,
            name: 'Block Print Kurta Set',
            category: 'Block Print',
            price: 4500,
            craft: 'Hand block printed in Jaipur',
            image: 'https://images.pexels.com/photos/8838890/pexels-photo-8838890.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 3,
            name: 'Khadi Cotton Dupatta',
            category: 'Khadi',
            price: 2200,
            craft: 'Hand-spun Khadi from Gujarat',
            image: 'https://images.pexels.com/photos/6764040/pexels-photo-6764040.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 4,
            name: 'Banarasi Zari Lehenga',
            category: 'Banarasi',
            price: 15999,
            craft: 'Woven by master weavers, Varanasi',
            image: 'https://images.pexels.com/photos/9419032/pexels-photo-9419032.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 5,
            name: 'Chikankari Anarkali',
            category: 'Chikankari',
            price: 6800,
            craft: 'Hand-embroidered in Lucknow',
            image: 'https://images.pexels.com/photos/7123307/pexels-photo-7123307.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 6,
            name: 'Handloom Linen Kurta',
            category: 'Khadi',
            price: 3500,
            craft: 'Handloom weavers of West Bengal',
            image: 'https://images.pexels.com/photos/17611651/pexels-photo-17611651.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 7,
            name: 'Ikat Silk Stole',
            category: 'Block Print',
            price: 4200,
            craft: 'Ikat weavers of Pochampally',
            image: 'https://images.pexels.com/photos/6764007/pexels-photo-6764007.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
        {
            id: 8,
            name: 'Ajrakh Print Dress',
            category: 'Block Print',
            price: 5800,
            craft: 'Ajrakh artisans of Kutch',
            image: 'https://images.pexels.com/photos/8838667/pexels-photo-8838667.jpeg?auto=compress&cs=tinysrgb&w=800',
        },
    ];

    const filteredProducts = activeFilter === 'All'
        ? products
        : products.filter(p => p.category === activeFilter);

    const sortedProducts = [...filteredProducts].sort((a, b) => {
        if (sortBy === 'price-low') return a.price - b.price;
        if (sortBy === 'price-high') return b.price - a.price;
        return 0;
    });

    const toggleWishlist = (e, productId) => {
        e.stopPropagation();
        setWishlist(prev => ({ ...prev, [productId]: !prev[productId] }));
    };

    const totalPages = 3;

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Cormorant+Infant:ital,wght@0,300;0,400;0,500;0,600;0,700;1,400&family=Source+Sans+3:wght@300;400;500;600;700&display=swap');

                .maati-shop-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 16px;
                }
                @media (min-width: 768px) {
                    .maati-shop-grid {
                        grid-template-columns: repeat(3, 1fr);
                        gap: 20px;
                    }
                }
                @media (min-width: 1024px) {
                    .maati-shop-grid {
                        grid-template-columns: repeat(4, 1fr);
                        gap: 24px;
                    }
                }
                .maati-filter-bar {
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                    align-items: center;
                }
                @media (min-width: 768px) {
                    .maati-filter-bar {
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }
                .maati-category-scroll {
                    display: flex;
                    gap: 10px;
                    overflow-x: auto;
                    padding-bottom: 4px;
                    -ms-overflow-style: none;
                    scrollbar-width: none;
                }
                .maati-category-scroll::-webkit-scrollbar {
                    display: none;
                }
                .maati-hero-section {
                    padding: 120px 24px 60px;
                }
                @media (min-width: 768px) {
                    .maati-hero-section {
                        padding: 140px 24px 80px;
                    }
                }
            `}</style>

            <div style={{ minHeight: '100vh', backgroundColor: '#FAF6F1' }}>
                <Header cartCount={0} />

                {/* Hero Banner */}
                <div
                    className="maati-hero-section"
                    style={{
                        backgroundColor: '#FAF6F1',
                        borderBottom: '1px solid #E8DDD0',
                        textAlign: 'center',
                    }}
                >
                    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                        <p
                            style={{
                                fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                fontSize: '12px',
                                fontWeight: 500,
                                color: '#C4572A',
                                letterSpacing: '4px',
                                textTransform: 'uppercase',
                                margin: '0 0 16px 0',
                            }}
                        >
                            Handcrafted with love
                        </p>
                        <h1
                            style={{
                                fontFamily: "'Cormorant Infant', Georgia, serif",
                                fontSize: 'clamp(36px, 6vw, 64px)',
                                fontWeight: 400,
                                color: '#5C3D2E',
                                letterSpacing: '3px',
                                margin: '0 0 16px 0',
                                lineHeight: 1.1,
                            }}
                        >
                            Our Collection
                        </h1>
                        <p
                            style={{
                                fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                fontSize: '16px',
                                fontWeight: 300,
                                color: '#8B7355',
                                margin: 0,
                                lineHeight: 1.6,
                            }}
                        >
                            Discover handwoven and hand-printed treasures celebrating India's timeless textile heritage
                        </p>
                    </div>
                </div>

                {/* Main Content */}
                <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '40px 24px 80px' }}>

                    {/* Filter / Sort Bar */}
                    <div className="maati-filter-bar" style={{ marginBottom: '40px' }}>
                        {/* Category Pills */}
                        <div className="maati-category-scroll">
                            {categories.map(category => (
                                <button
                                    key={category}
                                    onClick={() => {
                                        setActiveFilter(category);
                                        setCurrentPage(1);
                                    }}
                                    style={{
                                        fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                        fontSize: '13px',
                                        fontWeight: 500,
                                        letterSpacing: '1px',
                                        textTransform: 'uppercase',
                                        padding: '10px 24px',
                                        backgroundColor: activeFilter === category ? '#C4572A' : 'transparent',
                                        color: activeFilter === category ? '#FFFFFF' : '#5C3D2E',
                                        border: activeFilter === category ? '1px solid #C4572A' : '1px solid #E8DDD0',
                                        borderRadius: '30px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        whiteSpace: 'nowrap',
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeFilter !== category) {
                                            e.currentTarget.style.borderColor = '#C4572A';
                                            e.currentTarget.style.color = '#C4572A';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeFilter !== category) {
                                            e.currentTarget.style.borderColor = '#E8DDD0';
                                            e.currentTarget.style.color = '#5C3D2E';
                                        }
                                    }}
                                >
                                    {category}
                                </button>
                            ))}
                        </div>

                        {/* Sort Dropdown */}
                        <select
                            value={sortBy}
                            onChange={(e) => setSortBy(e.target.value)}
                            style={{
                                fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                fontSize: '13px',
                                padding: '10px 20px',
                                backgroundColor: '#FFFFFF',
                                color: '#5C3D2E',
                                border: '1px solid #E8DDD0',
                                borderRadius: '30px',
                                cursor: 'pointer',
                                outline: 'none',
                            }}
                        >
                            {sortOptions.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>

                    {/* Results Count */}
                    <p style={{
                        fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                        fontSize: '14px',
                        color: '#8B7355',
                        marginBottom: '24px',
                    }}>
                        Showing {sortedProducts.length} artisan {sortedProducts.length === 1 ? 'piece' : 'pieces'}
                    </p>

                    {/* Product Grid */}
                    <div className="maati-shop-grid">
                        {sortedProducts.map(product => (
                            <div
                                key={product.id}
                                onClick={() => navigate(`/template22/product/${product.id}`)}
                                onMouseEnter={() => setHoveredCard(product.id)}
                                onMouseLeave={() => setHoveredCard(null)}
                                style={{
                                    backgroundColor: '#FFFFFF',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    cursor: 'pointer',
                                    transition: 'all 0.4s ease',
                                    boxShadow: hoveredCard === product.id
                                        ? '0 12px 40px rgba(92, 61, 46, 0.12)'
                                        : '0 2px 12px rgba(92, 61, 46, 0.06)',
                                    transform: hoveredCard === product.id ? 'translateY(-4px)' : 'none',
                                    border: '1px solid #E8DDD0',
                                }}
                            >
                                {/* Image */}
                                <div style={{ position: 'relative', aspectRatio: '3/4', overflow: 'hidden' }}>
                                    <img
                                        src={product.image}
                                        alt={product.name}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'cover',
                                            transition: 'transform 0.6s ease',
                                            transform: hoveredCard === product.id ? 'scale(1.05)' : 'scale(1)',
                                        }}
                                    />
                                    {/* Wishlist Button */}
                                    <button
                                        onClick={(e) => toggleWishlist(e, product.id)}
                                        style={{
                                            position: 'absolute',
                                            top: '12px',
                                            right: '12px',
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '50%',
                                            backgroundColor: 'rgba(255,255,255,0.9)',
                                            border: 'none',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer',
                                            transition: 'all 0.3s ease',
                                        }}
                                    >
                                        <Heart
                                            size={16}
                                            fill={wishlist[product.id] ? '#C4572A' : 'none'}
                                            color={wishlist[product.id] ? '#C4572A' : '#5C3D2E'}
                                        />
                                    </button>
                                    {/* Craft Badge */}
                                    <div
                                        style={{
                                            position: 'absolute',
                                            bottom: '12px',
                                            left: '12px',
                                            backgroundColor: 'rgba(250, 246, 241, 0.92)',
                                            padding: '4px 12px',
                                            borderRadius: '20px',
                                            fontSize: '11px',
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            color: '#5C3D2E',
                                            fontWeight: 500,
                                            backdropFilter: 'blur(8px)',
                                        }}
                                    >
                                        {product.category}
                                    </div>
                                </div>

                                {/* Details */}
                                <div style={{ padding: '16px' }}>
                                    <h3
                                        style={{
                                            fontFamily: "'Cormorant Infant', Georgia, serif",
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            color: '#5C3D2E',
                                            margin: '0 0 4px 0',
                                            lineHeight: 1.3,
                                        }}
                                    >
                                        {product.name}
                                    </h3>
                                    <p
                                        style={{
                                            fontFamily: "'Source Sans 3', sans-serif",
                                            fontSize: '12px',
                                            color: '#8B7355',
                                            margin: '0 0 10px 0',
                                            fontStyle: 'italic',
                                        }}
                                    >
                                        {product.craft}
                                    </p>
                                    <p
                                        style={{
                                            fontFamily: "'Source Sans 3', -apple-system, sans-serif",
                                            fontSize: '16px',
                                            fontWeight: 600,
                                            color: '#C4572A',
                                            margin: 0,
                                        }}
                                    >
                                        {'\u20B9'}{product.price.toLocaleString('en-IN')}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination */}
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '8px',
                        marginTop: '60px',
                    }}>
                        <button
                            onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
                            disabled={currentPage === 1}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                border: '1px solid #E8DDD0',
                                backgroundColor: 'transparent',
                                color: currentPage === 1 ? '#E8DDD0' : '#5C3D2E',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: currentPage === 1 ? 'default' : 'pointer',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <ChevronLeft size={18} />
                        </button>

                        {[...Array(totalPages)].map((_, i) => (
                            <button
                                key={i + 1}
                                onClick={() => setCurrentPage(i + 1)}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    border: currentPage === i + 1 ? '1px solid #C4572A' : '1px solid #E8DDD0',
                                    backgroundColor: currentPage === i + 1 ? '#C4572A' : 'transparent',
                                    color: currentPage === i + 1 ? '#FFFFFF' : '#5C3D2E',
                                    fontFamily: "'Source Sans 3', sans-serif",
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                }}
                            >
                                {i + 1}
                            </button>
                        ))}

                        <button
                            onClick={() => setCurrentPage(p => Math.min(totalPages, p + 1))}
                            disabled={currentPage === totalPages}
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                border: '1px solid #E8DDD0',
                                backgroundColor: 'transparent',
                                color: currentPage === totalPages ? '#E8DDD0' : '#5C3D2E',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: currentPage === totalPages ? 'default' : 'pointer',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            <ChevronRight size={18} />
                        </button>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    );
};

export default Template22Shop;
